<div class="row g-3">
<!-- Año -->
 <div class="col-6">
    <label class="form-label">Año a reportar</label>
    <select
      class="form-select"
      [(ngModel)]="selectedYear"
      (ngModelChange)="onYearModelChange($event)"
    >
      <option [ngValue]="null" disabled>Seleccione</option>
      <option *ngFor="let year of years" [ngValue]="year">
        {{ year }}
      </option>
    </select>
  </div>

  <!-- Mes -->
  <div class="col-6">
    <label class="form-label">Mes a reportar</label>
    <select
      class="form-select"
      [(ngModel)]="selectedMonth"
      (ngModelChange)="onMonthModelChange($event)"
    >
      <option [ngValue]="null" disabled>Seleccione</option>
      <option *ngFor="let month of months" [ngValue]="month">
        {{ month.name }}
      </option>
    </select>
  </div>
</div>